
import { useRef } from 'react';

/**
 * Hook for managing permissions-related refs
 */
export const usePermissionsRefs = () => {
  const lastRefreshedRef = useRef<number>(0);
  const isRefreshingRef = useRef(false);
  const debounceTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const eventListenerCleanupRef = useRef<(() => void) | null>(null);
  const hasInitiallyRefreshedRef = useRef(false);

  return {
    lastRefreshedRef,
    isRefreshingRef,
    debounceTimeoutRef,
    eventListenerCleanupRef,
    hasInitiallyRefreshedRef,
  };
};
